export const GET_FIRMWARE_DATA = "GET_FIRMWARE_DATA";
export const SET_FIRMWARE_DATA = "SET_FIRMWARE_DATA";
export const UPDATE_FIRMWARE_DATA_STATUS = "UPDATE_FIRMWARE_DATA_STATUS";
export const GET_FIRMWARE_TYPE_DROPDOWN = "GET_FIRMWARE_TYPE_DROPDOWN";
